export default __webpack_public_path__ + "static/media/dm_hoat_chat.9c309c70.xlsx";